import { Button, ButtonBase } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from '../../axios/axios';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { fetchBonus } from '../../redux/slice/bonusSlice';
import dayjs from 'dayjs';
import { Checkbox, DatePicker, InputNumber, Modal, Select } from 'antd';
import {
  Controller,
  FormProvider,
  useFieldArray,
  useForm,
} from 'react-hook-form';
import { Popover } from 'antd';

const AddDealerBonus = (props) => {
  const dispatch = useDispatch();
  const { editData } = props;
  const [animClass, setAnimClass] = useState('invisible translate-x-[100%]');
  const [checkBox, setcheckBox] = useState('per');
  const [bTerms, setBTerms] = useState(false);
  const [bTermsModal, setBTermsModal] = useState(false);
  const [conflictMsg, setConflictMsg] = useState('');
  const methods = useForm({
    defaultValues: {
      name: '',
      bonus_per: '',
      bonus_dlr: '',
      startDate: '',
      endDate: '',
      payout_days: '',
      bonus_distribution_period: '',
      bonAdminFee: [
        {
          admin_fee: '125',
          minimum_loan_amount: '',
          maximum_loan_amount: '',
          bonus_type: 'per',
        },
      ],
    },
  });
  const {
    register,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'bonAdminFee',
  });
  const bonusDisPer = watch('bonus_distribution_period');
  const minLonVal = watch('minimum_loan_amount');
  const [formData, setFormData] = useState({
    id: '',
    edit: false,
    bonus_type: 1,
  });
  const [loanDisbData, setLoanDisbData] = useState([]);
  const [errorText, setErrorText] = useState('');
  console.log('errorText', errorText);
  const getSettings = async () => {
    const resp = await axios.get('/settings');
    setLoanDisbData(resp?.data?.data?.loanBonusDistributionPeriods);
  };
  const handleBonusType = (e) => {
    setcheckBox(e.target.value);
    const BonusType = e.target.value === 'per' ? 1 : 2;
    setFormData({
      ...formData,
      bonus_type: BonusType,
    });
  };

  const handleAddItem = () => {
    append({
      admin_fee: '',
      minimum_loan_amount: '',
      maximum_loan_amount: '',
      bonus_type: 'per',
    });
  };

  const handleRemoveItem = (index) => {
    remove(index);
  };

  const handleHookSubmit = async (data) => {
    const accessToken = localStorage.getItem('agentModuleToken');
    let errCount = 0;
    setConflictMsg('');
    console.log(data?.bonAdminFee);
    const qualfData = data?.bonAdminFee.map((item) => {
      return {
        bonus: String(item?.admin_fee),
        minimum_loan_amount: String(item?.minimum_loan_amount),
        maximum_loan_amount: String(item?.maximum_loan_amount),
        bonus_type: item.bonus_type === 'per' ? 1 : 2,
      };
    });
    data.bonAdminFee.forEach((item) => {
      if (
        parseFloat(item.maximum_loan_amount) <=
        parseFloat(item.minimum_loan_amount)
      ) {
        setConflictMsg(
          'Loan amount is conflicting, pls create without conflicting loan amount'
        );
        errCount++;
      }
    });
    data.bonAdminFee.sort((a, b) => {
      const min1 = parseFloat(a.minimum_loan_amount);
      const max1 = parseFloat(a.maximum_loan_amount);
      const min2 = parseFloat(b.minimum_loan_amount);
      const max2 = parseFloat(b.maximum_loan_amount);
      if ((min1 <= min2 && max1 >= min2) || (min1 >= min2 && min1 <= max2)) {
        setConflictMsg(
          'Loan amount is conflicting, pls create without conflicting loan amount'
        );
        errCount++;
      }
    });
    if (errCount === 0) {
      const postData = {
        name: data.name,
        startDate: dayjs(data.startDate).format('YYYY-MM-DD'),
        endDate: dayjs(data.endDate).format('YYYY-MM-DD'),
        payout_days: String(data.payout_days),
        bonus_distribution_period: data.bonus_distribution_period,
        qualifying_loan_amounts: qualfData,
      };
      if (formData.edit) {
        const resp = await axios.put(
          `/loan/bonus/update/${formData.id}`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        dispatch(fetchBonus());
        if (resp?.data?.resp_code) {
          props.closeBonusPopUp();
          toast.success('Updated Successfully');
        }
      } else {
        try {
          const resp = await axios.post('/loan/bonus/create', postData, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          dispatch(fetchBonus());
          if (resp?.data?.resp_code === 200) {
            props.closeBonusPopUp();
            toast.success('Added Successfully');
          }
        } catch (err) {
          console.log('ERROR', err?.response?.data?.errors?.existing_record);
          if (err?.response?.data?.errors?.existing_record !== undefined) {
            setErrorText(err?.response?.data?.errors?.existing_record);
          } else {
            setErrorText("Dealer Bonus with same data alreadt exist's");
          }
        }
      }
    }
  };

  useEffect(() => {
    getSettings();
    if (editData) {
      console.log(editData);
      let QualLoanAmt = [];
      if (editData.qualifying_loan_amounts.length > 0) {
        QualLoanAmt = editData.qualifying_loan_amounts.map((item) => {
          return { ...item, admin_fee: item.bonus };
        });
      }
      const {
        id,
        bonus,
        bonus_distribution_period,
        bonus_type,
        endDate,
        name,
        payout_days,
        startDate,
      } = editData;
      setFormData({
        ...formData,
        id: id,
        edit: true,
        bonus_type,
      });
      setValue('name', name);
      setValue('startDate', dayjs(startDate));
      setValue('endDate', dayjs(endDate));
      setValue('bonus_distribution_period', bonus_distribution_period);
      setValue('payout_days', payout_days);
      setValue(
        'bonAdminFee',
        QualLoanAmt.map((qAm) => {
          return {
            ...qAm,
            bonus_type: qAm.bonus_type == 1 ? 'per' : 'dol',
          };
        })
      );
      if (bonus_type === 1) {
        setValue('bonus_per', bonus);
        setcheckBox('per');
      } else {
        setValue('bonus_dlr', bonus);
        setcheckBox('dol');
      }
      console.log(getValues());
    }
  }, []);
  useEffect(() => {
    document.querySelector('body').classList.add('body_scroll_hid');
    setAnimClass('visible translate-x-[0%]');
    return () => {
      document.querySelector('body').classList.remove('body_scroll_hid');
      setAnimClass('invisible translate-x-[100%]');
    };
  }, []);

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf('day');
  };

  let tootipText = (
    <div className='w-[200px] pt-[10px] pb-[5px]'>
      <p className='my-[7px] text-[12px]'>
        Once the dealer has cross the qualifying loan amount to the next tier,
        the bonus payout percentage or fixed rate will supercede that of the
        previous tier.
      </p>
    </div>
  );
  return (
    <div
      className={`bg-black bg-opacity-50 fixed z-[999]  w-[100%] h-full left-0 top-0`}
    >
      <Modal
        title='Terms & Conditions'
        centered
        open={bTermsModal}
        footer={false}
        onCancel={() => setBTermsModal(false)}
      >
        <p>
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout. The point of
          using Lorem Ipsum is that it has a more-or-less normal distribution of
          letters, as opposed to using 'Content here, content here', making it
          look like readable English. Many desktop publishing packages and web
          page editors now use Lorem Ipsum as their default model text, and a
          search for 'lorem ipsum' will uncover many web sites still in their
          infancy. Various versions have evolved over the years, sometimes by
          accident, sometimes on purpose (injected humour and the like).
        </p>
      </Modal>
      <div
        className={`w-[550px] max-w-[100%] max-w-2xl bg-white absolute rounded-t-lg md:rounded-none bottom-0 h-[100%] md:h-[100%] right-0 max-h-screen overflow-y-scroll scBarHidden popupAnim ${animClass}`}
      >
        <div className='relative py-2 pt-14'>
          <div className='absolute bg-white w-[100%] top-0'>
            <div className='flex px-4 py-2 pt-4 md:px-8 md:py-4 justify-between items-center z-9 w-[100%]'>
              <h3 className='text-md font-bold tracking-[-.15px] capitalize'>
                {formData.edit ? 'Edit Dealer Bonus' : 'Add Dealer Bonus'}
              </h3>
              <div
                className='bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer'
                onClick={() => props.closeBonusPopUp()}
              >
                <img src='/images/x-circle.svg' className='w-5 h-5' />
              </div>
            </div>
          </div>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(handleHookSubmit)} noValidate>
              <div className='px-4 py-2 pt-4 md:px-8 md:py-4 md:pt-6 w-full'>
                <div>
                  <label className='block mb-[6px] font-[500] text-[13px] text-[#495159] flex justify-between items-center'>
                    Dealer Bonus Name
                    <p className='text-[red] text-[12px] errMsg mb-[0]'>
                      Mandatory
                    </p>
                  </label>
                  <input
                    type='text'
                    name='name'
                    placeholder='Bonus Name'
                    className={`w-[100%] popInput ${
                      errors?.name && 'border-[#ff4d4f!important]'
                    }`}
                    {...register('name', { required: true })}
                  />
                </div>
                <div className='flex flex-wrap items-center my-[25px] gap-[0px_10px] cus_date_pick'>
                  <label className='block w-full mb-[6px] text-[13px] text-[#495159] font-[500] flex justify-between items-center'>
                    Bonus Program Validity Period
                    <p className='text-[red] text-[12px] errMsg mb-[0]'>
                      Mandatory
                    </p>
                  </label>
                  <div className='datePickAnt'>
                    <Controller
                      control={control}
                      name='startDate'
                      rules={{
                        required: true,
                      }}
                      render={({ field }) => {
                        return (
                          <DatePicker
                            placeholder='DD-MM-YYYY'
                            status={errors?.startDate ? 'error' : null}
                            name={field.name}
                            ref={field.ref}
                            format={'DD-MM-YYYY'}
                            className={`py-[8px]`}
                            disabled={formData.edit}
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(date) => {
                              field.onChange(date ? date.valueOf() : null);
                              setValue('endDate', '');
                            }}
                            disabledDate={disabledDate}
                          />
                        );
                      }}
                    />
                  </div>
                  <span className='mx-[10px] max-[500px]:w-full max-[500px]:my-[10px]'>
                    To
                  </span>
                  <div className='datePickAnt'>
                    <Controller
                      control={control}
                      name='endDate'
                      rules={{
                        required: true,
                      }}
                      render={({ field }) => {
                        return (
                          <DatePicker
                            placeholder='DD-MM-YYYY'
                            status={errors?.endDate ? 'error' : null}
                            name={field.name}
                            ref={field.ref}
                            format={'DD-MM-YYYY'}
                            className={`py-[8px]`}
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(date) => {
                              field.onChange(date ? date.valueOf() : null);
                            }}
                            disabledDate={(d) =>
                              d.isBefore(dayjs(watch('startDate')))
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>
                {conflictMsg && (
                  <div className='mb-[10px] text-[14px] text-[red] font-[500]'>
                    {conflictMsg}
                  </div>
                )}
                {fields.map((field, index) => {
                  return (
                    <div
                      className='flex flex-wrap items-center gap-[10px_10px] mb-[10px] last:mb-0'
                      key={field.id}
                    >
                      <div className='flex items-center gap-[0_10px] flex-wrap'>
                        <label className='block w-full mb-[6px] text-[13px] text-[#495159] font-[500] flex justify-between items-center'>
                          Qualifying Loan Amount - Tier {index + 1}
                        </label>
                        <div>
                          <Controller
                            control={control}
                            name={`bonAdminFee.[${index}].minimum_loan_amount`}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => {
                              return (
                                <InputNumber
                                  type='number'
                                  min={0}
                                  prefix='$'
                                  value={field.value}
                                  name={field.name}
                                  ref={field.ref}
                                  prefixCls='sign_Icon'
                                  placeholder='0.00'
                                  precision={2}
                                  status={
                                    errors?.bonAdminFee?.[index]
                                      ?.minimum_loan_amount
                                      ? 'error'
                                      : null
                                  }
                                  disabled={formData.edit}
                                  step='0.01'
                                  className='cusAdmInputNumber2'
                                  onChange={(val) => field.onChange(val)}
                                />
                              );
                            }}
                          />
                        </div>
                        <span className='mx-[10px] max-[400px]:w-full max-[400px]:my-[10px]'>
                          to
                        </span>
                        <div className=''>
                          <Controller
                            control={control}
                            name={`bonAdminFee.[${index}].maximum_loan_amount`}
                            rules={{
                              required: true,
                              validate: (val) => {
                                if (val <= minLonVal) {
                                  return 'Maximum loan amount must be greater than Minimum amount';
                                }
                                return true;
                              },
                            }}
                            render={({ field }) => {
                              return (
                                <InputNumber
                                  type='number'
                                  min={0}
                                  prefix='$'
                                  name={field.name}
                                  ref={field.ref}
                                  value={field.value}
                                  status={
                                    errors?.bonAdminFee?.[index]
                                      ?.maximum_loan_amount
                                      ? 'error'
                                      : null
                                  }
                                  prefixCls='sign_Icon'
                                  placeholder='0.00'
                                  precision={2}
                                  step='0.01'
                                  disabled={formData.edit}
                                  className='cusAdmInputNumber2'
                                  onChange={(val) => field.onChange(val)}
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <label className='block w-full mb-[6px] text-[13px] text-[#495159] font-[500] flex justify-between items-center'>
                          Bonus Amount
                          {index == 0 && (
                            <Popover content={tootipText} placement='top'>
                              <img
                                src='images/fi_info.svg'
                                alt='info'
                                className='inline-block ml-[8px] cursor-pointer'
                              />
                            </Popover>
                          )}
                        </label>
                        <div className='relative'>
                          <Controller
                            control={control}
                            name={`bonAdminFee.[${index}].admin_fee`}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => {
                              return (
                                <InputNumber
                                  type='number'
                                  min={0}
                                  status={
                                    errors?.bonAdminFee?.[index]?.admin_fee
                                      ? 'error'
                                      : null
                                  }
                                  value={field.value}
                                  name={field.name}
                                  ref={field.ref}
                                  placeholder='0.00'
                                  precision={2}
                                  step='0.01'
                                  disabled={formData.edit}
                                  className='cusAdmInputNumber2 incHidd'
                                  onChange={(val) => field.onChange(val)}
                                  addonAfter={
                                    <Controller
                                      control={control}
                                      name={`bonAdminFee.[${index}].bonus_type`}
                                      render={({ field }) => {
                                        return (
                                          <Select
                                            value={field.value}
                                            style={{ width: 55 }}
                                            ref={field.ref}
                                            rootClassName='bSel'
                                            options={[
                                              {
                                                label: '$',
                                                value: 'dol',
                                              },
                                              {
                                                label: '%',
                                                value: 'per',
                                              },
                                            ]}
                                            disabled={formData.edit}
                                            onChange={(val) =>
                                              field.onChange(val)
                                            }
                                          />
                                        );
                                      }}
                                    />
                                  }
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                      {!formData.edit && (
                        <div className='flex gap-[5px] min-w-[44px]'>
                          {index === 0 && (
                            <div className='flex-shrink-0'>
                              <ButtonBase
                                disableTouchRipple
                                disabled={fields.length >= 3}
                                className={`${
                                  fields.length >= 3 && 'opacity-[0.5]'
                                }`}
                              >
                                <span
                                  className='cursor-pointer mt-[24px] max-[700px]:mt-[10px] flex-shrink-0'
                                  onClick={handleAddItem}
                                >
                                  <img
                                    src='/images/fi_plus-circle2.svg'
                                    alt='add icon'
                                  />
                                </span>
                              </ButtonBase>
                            </div>
                          )}
                          {fields.length > 1 && (
                            <span
                              className='cursor-pointer mt-[24px] max-[700px]:mt-[10px] flex-shrink-0'
                              onClick={() => handleRemoveItem(index)}
                            >
                              <img
                                src='/images/fi_minus-circle2.svg'
                                alt='add icon'
                              />
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
                {errorText !== '' && (
                  <p className='text-[13px] text-[#ff4d4f]'>{errorText}</p>
                )}
                <div className='mt-[25px]'>
                  <label className='block mb-[6px] font-[500] text-[13px] text-[#495159] flex justify-between items-center'>
                    Quantifying Loan Distribution Period
                    <p className='text-[red] text-[12px] errMsg mb-[0]'>
                      Mandatory
                    </p>
                  </label>
                  <select
                    className={`px-2 pr-0 popUPSelect ${
                      errors?.bonus_distribution_period &&
                      'border-[#ff4d4f!important]'
                    } ${
                      formData.edit &&
                      'pointer-events-none bg-[#0000000a!important] opacity-[0.6]'
                    }`}
                    name='bonus_distribution_period'
                    {...register('bonus_distribution_period', {
                      required: true,
                    })}
                    value={bonusDisPer}
                  >
                    <option value=''>Select Distribution Period</option>
                    {loanDisbData.map((item, idx) => {
                      return (
                        <option key={idx} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className='mt-[25px]'>
                  <label className='block mb-[12px] font-[500] text-[13px] text-[#495159] flex justify-between items-center'>
                    Payout
                    <p className='text-[red] text-[12px] errMsg mb-[0]'>
                      Mandatory
                    </p>
                  </label>
                  <div className='flex items-center'>
                    <span className='mr-[8px] text-[13px] text-[#495159]'>
                      within
                    </span>
                    <input
                      type='number'
                      min={0}
                      placeholder='7'
                      className={`popInput w-[60px] ${
                        errors?.payout_days && 'border-[#ff4d4f!important]'
                      } ${
                        formData.edit &&
                        'pointer-events-none bg-[#0000000a!important] opacity-[0.6]'
                      }`}
                      name='payout_days'
                      {...register('payout_days', { required: true })}
                      defaultValue='payout_days'
                    />
                    <span className='ml-[8px] text-[13px] text-[#495159]'>
                      day(s) after end of Qualifying Period
                    </span>
                  </div>
                </div>
                <div className='flex items-center gap-[12px] mt-[20px] cursor-pointer'>
                  <Checkbox
                    id='b_terms'
                    checked={bTerms}
                    onChange={(e) => setBTerms(e.target.checked)}
                  />
                  <span>
                    <label htmlFor='b_terms' className='cursor-pointer'>
                      I agree to the bonus
                    </label>{' '}
                    <b
                      onClick={(e) => {
                        e.stopPropagation();
                        setBTermsModal(true);
                      }}
                      className='text-[#0560fb]'
                    >
                      terms and conditions
                    </b>
                  </span>
                </div>
                <div className='mt-[35px]'>
                  <Button type='submit' className='sav_btn' disabled={!bTerms}>
                    Confirm
                  </Button>
                  <Button
                    type='button'
                    className='can_btn'
                    onClick={() => props.closeBonusPopUp()}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default AddDealerBonus;
